import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ImageChatMessageService } from '@examdojo/chat';
import { assertNonNullable } from '@examdojo/core/util/assert';
import { isNotNullish } from '@examdojo/core/util/nullish';
import { ReferenceQuestionQuery } from '@examdojo/reference-question';
import { ReviewItemHttpService } from '@examdojo/review';
import { UserQuery } from '@examdojo/user';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs';

@Injectable()
export class ReferenceQuestionImageChatEffectService {
  constructor(
    private readonly imageChatMessageService: ImageChatMessageService,
    private readonly referenceQuestionQuery: ReferenceQuestionQuery,
    private readonly reviewItemHttpService: ReviewItemHttpService,
    private readonly userQuery: UserQuery,
  ) {
    this.fetchReferenceQuestionImageChats().pipe(takeUntilDestroyed()).subscribe();
  }

  private fetchReferenceQuestionImageChats() {
    return this.referenceQuestionQuery.selectActiveId().pipe(
      filter(isNotNullish),
      distinctUntilChanged(),
      switchMap((refQuestionId) => {
        const userId = this.userQuery.getActiveId();
        assertNonNullable(userId, 'User ID not found');

        return this.reviewItemHttpService.fetchByReferenceQuestionId(refQuestionId).pipe(
          map((reviewItems) => reviewItems[0]),
          filter(isNotNullish),
          switchMap((reviewItem) => this.imageChatMessageService.fetchReviewImageChats(reviewItem.id, userId)),
        );
      }),
    );
  }
}
